import { Dictionary } from 'vuex';

import { MdokResource, mdokResource } from '@/resources/mdok.resource';
import { AbstractModule } from './abstract.module';

/**
 * Moduł MDOK
 *
 * @export
 * @class MdokModule
 * @extends {AbstractModule<MdokResource>}
 */
export class MdokModule extends AbstractModule<MdokResource> {
  public state: object = { name: undefined, caseName: undefined };
  public actions: Dictionary<(...args: any[]) => any> = {
    /**
     * Pobiera nazwę dokumentu z MDOK
     *
     * @param {*} context
     * @param {{ uid: number; documentId: number }} variables
     * @returns {Promise<string>}
     */
    getDocumentName: (context: any, variables: { uid: number; documentId: number }): Promise<string> =>
      this.resource
        .getDocumentName(variables)
        .then(name => {
          context.commit('saveDocumentName', name);
          return name;
        })
        .catch(err => {
          context.commit('saveDocumentName', null);
          throw err;
        }),

    /**
     * Pobiera nazwę dokumentu i datę dostarczenia z MDOK
     *
     * @param {*} context
     * @param {{ uid: number; documentId: number }} variables
     * @returns {Promise<{name: string, date?: Date}>}
     */
    getDocumentNameAndIncomeDate: (
      context: any,
      variables: { uid: number; documentId: number }
    ): Promise<{ name: string; date?: Date }> =>
      this.resource
        .getDocumentNameAndIncomeDate(variables)
        .then(data => {
          context.commit('saveDocumentName', data.name);
          return data;
        })
        .catch(err => {
          context.commit('saveDocumentName', null);
          throw err;
        }),

    /**
     * Pobiera nazwę dokumentu i dane z MDOK
     *
     * @param {*} context
     * @param {{ uid: number; documentId: number }} variables
     * @returns {Promise<{ name: string; data?: any }>}
     */
    getDocumentNameAndData: (
      context: any,
      variables: { uid: number; documentId: number }
    ): Promise<{ name: string; data?: any }> =>
      this.resource
        .getDocumentNameAndData(variables)
        .then(data => {
          context.commit('saveDocumentName', data.name);
          return data;
        })
        .catch(err => {
          context.commit('saveDocumentName', null);
          throw err;
        }),

    /**
     * Pobiera nazwę sprawy z MDOK
     *
     * @param {*} context
     * @param {{ uid: number; documentId: number }} variables
     * @returns {Promise<string>}
     */
    getCaseName: (context: any, variables: { uid: number; documentId: number }): Promise<string> =>
      this.resource
        .getCaseName(variables)
        .then(name => {
          context.commit('saveCaseName', name);
          return name;
        })
        .catch(err => {
          context.commit('saveCaseName', null);
          throw err;
        })
  };
  public mutations: Dictionary<(...args: any[]) => void> = {
    /**
     * Zapisuje nazwę dokumentu
     *
     * @param {*} localState
     * @param {string} name
     */
    saveDocumentName(localState: any, name: string): void {
      localState.name = name;
    },

    /**
     * Zapisuje nazwę sprawy
     *
     * @param {*} localState
     * @param {string} name
     */
    saveCaseName(localState: any, name: string): void {
      localState.caseName = name;
    }
  };
}

export default new MdokModule(mdokResource);
